import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Message } from 'src/app/interfaces/Message';
import { ChatbotService } from 'src/app/services/chatbot.service';
import { DesktopService } from 'src/app/services/desktop.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { TitleService } from 'src/app/services/title.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-message-details',
    templateUrl: './message-details.page.html',
    styleUrls: ['./message-details.page.scss']
})
export class MessageDetailsPageComponent implements OnInit {
    public code: string = null;

    public message: Message;

    public userMessage = '';

    constructor(private ls: LocalStorageService, private router: Router, private navController: NavController, private desktopService: DesktopService, private chatbot: ChatbotService, private titleService: TitleService) {
        const generated_code: number[] = this.ls.getLS('generated_code');
        this.code = generated_code.join('');

        let message: Message = environment.all_messages.find(row => row.id === 1);

        // This is useless in the production environment
        if (this.router.getCurrentNavigation()?.extras && typeof this.router.getCurrentNavigation().extras.state !== 'undefined') message = this.router.getCurrentNavigation().extras?.state.message;

        if (this.ls.getLS('set-email-code') !== null) this.code = `Code: ${this.ls.getLS('set-email-code')}`;

        this.message = message;

        this.titleService.setTitle('Experience | Messages');
    }

    ngOnInit() {
        if (this.message) return;

        if (this.desktopService.isDesktop()) {
            this.navController.navigateBack([{ outlets: { mobile: ['messages'] } }]);
        } else {
            this.navController.navigateBack([{ outlets: { primary: ['messages'] } }]);
        }
    }

    /**
   * Pushes a message into the conversation based on the chatbot service
   * @param form
   * @returns
   */
    public sendMessage(form: NgForm) {
        if (!form.form.value.message) return;

        const conversation = {
            person: 'me',
            message: form.form.value.message
        };

        this.message.conversation.push(conversation);

        setTimeout(() => {
            this.message.conversation.push({
                person: 'them',
                message: this.chatbot.react(form.form.value.message)
            });
        }, 1000);
    }

    navigateBackToVerificationScreen() {
        return this.router.navigate(['enter-validation-code']);
    }
}
